"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const FontAwesome = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  name,
  sharp,
  variant = 'regular',
  size = 23,
  color = _.Color.neutral._90
}) => {
  const composed_classname = (0, _bind.default)(`fa-${variant} fa-${name}`, {
    'fa-sharp': sharp
  }, className);
  const composed_styles = {
    color,
    fontSize: size
  };
  return _react.default.createElement("i", {
    "data-testid": dataTestId,
    className: composed_classname,
    style: composed_styles
  });
});
var _default = FontAwesome;
exports.default = _default;